module.exports = __webpack_public_path__ + "static/media/cake.f0837cbd.bin";